"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadSymbolNameUtils = exports.KicadSymbolNameParser = void 0;
class KicadSymbolNameParser {
    static parseLibId(libId) {
        const colonIndex = libId.indexOf(':');
        if (colonIndex !== -1) {
            return {
                libraryName: libId.substring(0, colonIndex),
                symbolName: libId.substring(colonIndex + 1),
                originalLibId: libId,
            };
        }
        else {
            return {
                symbolName: libId,
                originalLibId: libId,
            };
        }
    }
    static parseSymbolName(symbolName) {
        const libIdInfo = this.parseLibId(symbolName);
        const nameToProcess = libIdInfo.symbolName;
        const subSymbolMatch = nameToProcess.match(/^(.+)_(\d+)_(\d+)$/);
        if (subSymbolMatch) {
            const rootName = subSymbolMatch[1];
            const unit = parseInt(subSymbolMatch[2], 10);
            const bodyStyle = parseInt(subSymbolMatch[3], 10);
            const rootInfo = this.parseRootSymbolName(rootName);
            return {
                ...rootInfo,
                isSubSymbol: true,
                unit,
                bodyStyle,
                originalName: symbolName,
            };
        }
        else {
            const rootInfo = this.parseRootSymbolName(nameToProcess);
            return {
                ...rootInfo,
                isSubSymbol: false,
                originalName: symbolName,
            };
        }
    }
    static parseRootSymbolName(rootName) {
        const parts = rootName.split('_');
        if (parts.length < 3) {
            return {
                sheetName: undefined,
                orientation: undefined,
                isMirrored: false,
                libraryReference: rootName,
                displayMode: undefined,
            };
        }
        let partIndex = 0;
        const sheetName = parts[partIndex++];
        const orientationStr = parts[partIndex++];
        const orientation = parseInt(orientationStr, 10);
        if (isNaN(orientation)) {
            return {
                sheetName: undefined,
                orientation: undefined,
                isMirrored: false,
                libraryReference: rootName,
                displayMode: undefined,
            };
        }
        let isMirrored = false;
        if (partIndex < parts.length && parts[partIndex] === 'mirrored') {
            isMirrored = true;
            partIndex++;
        }
        if (partIndex >= parts.length) {
            throw new Error(`Invalid root symbol name format: ${rootName}. Missing library reference.`);
        }
        const remainingParts = parts.slice(partIndex);
        let displayMode;
        let libraryReferenceParts = remainingParts;
        if (remainingParts.length > 1) {
            const lastPart = remainingParts[remainingParts.length - 1];
            const lastPartAsNumber = parseInt(lastPart, 10);
            if (!isNaN(lastPartAsNumber)) {
                displayMode = lastPartAsNumber;
                libraryReferenceParts = remainingParts.slice(0, -1);
            }
        }
        const libraryReference = libraryReferenceParts.join('_');
        return {
            sheetName,
            orientation,
            isMirrored,
            libraryReference,
            displayMode,
        };
    }
    static reconstructSymbolName(info) {
        if (info.sheetName === undefined || info.orientation === undefined) {
            let name = info.libraryReference;
            if (info.isSubSymbol && info.unit !== undefined && info.bodyStyle !== undefined) {
                name += `_${info.unit}_${info.bodyStyle}`;
            }
            return name;
        }
        let name = info.sheetName;
        name += `_${info.orientation}`;
        if (info.isMirrored) {
            name += '_mirrored';
        }
        name += `_${info.libraryReference}`;
        if (info.displayMode !== undefined) {
            name += `_${info.displayMode}`;
        }
        if (info.isSubSymbol && info.unit !== undefined && info.bodyStyle !== undefined) {
            name += `_${info.unit}_${info.bodyStyle}`;
        }
        return name;
    }
    static getRootSymbolName(symbolName) {
        const info = this.parseSymbolName(symbolName);
        return this.reconstructSymbolName({
            ...info,
            isSubSymbol: false,
            unit: undefined,
            bodyStyle: undefined,
        });
    }
}
exports.KicadSymbolNameParser = KicadSymbolNameParser;
class KicadSymbolNameUtils {
    static isSubSymbol(symbolName) {
        try {
            return KicadSymbolNameParser.parseSymbolName(symbolName).isSubSymbol;
        }
        catch {
            return false;
        }
    }
    static generateSubSymbolNames(rootSymbolName, maxUnits = 4, maxBodyStyles = 2) {
        const subSymbols = [];
        for (let unit = 0; unit <= maxUnits; unit++) {
            for (let bodyStyle = 0; bodyStyle < maxBodyStyles; bodyStyle++) {
                subSymbols.push(`${rootSymbolName}_${unit}_${bodyStyle}`);
            }
        }
        return subSymbols;
    }
    static getOrientationDescription(orientation) {
        switch (orientation) {
            case 0:
                return 'rightwards (0°)';
            case 1:
                return 'upwards (90°)';
            case 2:
                return 'leftwards (180°)';
            case 3:
                return 'downwards (270°)';
            default:
                return `unknown (${orientation})`;
        }
    }
}
exports.KicadSymbolNameUtils = KicadSymbolNameUtils;
//# sourceMappingURL=kicadSymbolParser.js.map